import { render, staticRenderFns } from "./HomeAds.vue?vue&type=template&id=1653a938&"
import script from "./HomeAds.vue?vue&type=script&lang=js&"
export * from "./HomeAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports